import { Modal } from '@opengov/component-library/dist';
import { ISavedView } from '@opengov/reporting-types/src/reportSavedView';
import { useToastContext } from '../../../../../src/components/Toast/contexts/useToast.context';
import { ToastProps } from '../../../../../src/components/Toast/Toast';

import React from 'react';
import { NavigateFunction } from 'react-router-dom';

import { IReportLocale } from '../../../../common/locale';
import { SavedViewFormFields } from '../savedViewForm/SavedViewFormFields';
import { ISavedViewTitleAndDescription, useSavedViewForm } from '../savedViewForm/useSavedViewForm';

import styles from './DimensionalSavedViewCreatingModal.scss';

export type { ISavedViewTitleAndDescription };

export interface IDimensionalSavedViewCreatingModal {
  categorizedBy: string;
  organizedBy: string;
  reportLocaleText: IReportLocale;
  showColumnName: string;
  existingSavedViews?: ISavedView[];
  onClose(): void;
  onCreate(
    savedView: ISavedViewTitleAndDescription,
    navigate: NavigateFunction,
    toggleToast: (toastProps: ToastProps) => void
  ): void;
}

export const DimensionalSavedViewCreatingModal = (props: IDimensionalSavedViewCreatingModal) => {
  const { toggleToast } = useToastContext();
  const form = useSavedViewForm(props.existingSavedViews);

  const handleCreate = () => {
    props.onCreate({ title: form.title, description: form.description }, form.navigate, toggleToast);
  };

  const {
    onClose,
    reportLocaleText: {
      cancel,
      description,
      savedView: {
        enterViewName,
        modal: { createView, titleDuplicate, titlePlaceHolder }
      }
    }
  } = props;

  return (
    <Modal.Work title={props.reportLocaleText.savedView.modal.title} onClose={onClose}>
      <div className={styles.borders}>
        <SavedViewFormFields
          form={form}
          localeText={{ cancel, createView, description, enterViewName, titleDuplicate, titlePlaceHolder }}
          onClose={onClose}
          onSubmit={handleCreate}
        />
      </div>
    </Modal.Work>
  );
};
